import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBoxSaleStatus } from '../../enums/admin-box-sale-status';
import { AdminBoxSaleContextOperationsResponse } from './admin-box-sale-context-operations.response';
import { AdminBoxSaleBoxResponse } from './admin-box-sale-box.response';

@jsonObject
export class AdminBoxSaleCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(AdminBoxSaleBoxResponse)
  public readonly box!: AdminBoxSaleBoxResponse;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly status!: AdminBoxSaleStatus;

  @jsonMember(Boolean)
  public readonly isContentPublic!: boolean;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminBoxSaleContextOperationsResponse)
  public readonly contextOperations!: AdminBoxSaleContextOperationsResponse;
}
